module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "add-form-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "new-form-modal"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-form-modal.Form Name')
    }
  }, [_c('label', {
    attrs: {
      "for": "fb-formname"
    }
  }, [_vm._v("Form Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newFormName),
      expression: "newFormName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fb-formname",
      "name": "Form Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFormName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFormName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-form-modal.Form Name')),
      expression: "errors.has('new-form-modal.Form Name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-form-modal.Form Name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-form-modal.Description')
    }
  }, [_c('label', {
    attrs: {
      "for": "fb-formdesc"
    }
  }, [_vm._v("Form Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newFormDesc),
      expression: "newFormDesc"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fb-formdesc",
      "name": "Description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFormDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFormDesc = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-form-modal.Description')),
      expression: "errors.has('new-form-modal.Description')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-form-modal.Description')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Create From Template")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createFromTemplate),
      expression: "createFromTemplate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Template"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.createFromTemplate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.templates), function(template) {
    return _c('option', {
      domProps: {
        "value": template.id
      }
    }, [_vm._v(_vm._s(template.name) + "\n                                ")])
  })], 2)]), _vm._v(" "), (_vm.newFormType == 'form' && !(_vm.modules.length === 1 && _vm.preselectedModule !== undefined)) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-form-modal.Related')
    }
  }, [_c('label', [_vm._v("Related to")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFormModule),
      expression: "newFormModule"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Related",
      "disabled": this.lockModuleSelect
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newFormModule = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.modules), function(module) {
    return _c('option', {
      domProps: {
        "value": module.key
      }
    }, [_vm._v(_vm._s(module.name))])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-form-modal.Related')),
      expression: "errors.has('new-form-modal.Related')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-form-modal.Related')))])]) : _vm._e(), _vm._v(" "), (_vm.userAccessLevels) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-form-modal.User Access')
    }
  }, [_c('label', [_vm._v("User access")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFormAccessLevel),
      expression: "newFormAccessLevel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "User Access"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newFormAccessLevel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.userAccessLevels), function(accessLevel) {
    return _c('option', {
      domProps: {
        "value": accessLevel.key
      }
    }, [_vm._v(_vm._s(accessLevel.name) + "\n                                ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-form-modal.User Access')),
      expression: "errors.has('new-form-modal.User Access')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-form-modal.User Access')))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button add-form-btn",
    attrs: {
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addFormAction.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Add Form")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("ADD NEW FORM")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f41f410c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/modals/AddFormModal.vue
// module id = 1757
// module chunks = 1